import { render, staticRenderFns } from "./FoodSafetyPanel.vue?vue&type=template&id=06408a8a&scoped=true"
import script from "./FoodSafetyPanel.vue?vue&type=script&lang=js"
export * from "./FoodSafetyPanel.vue?vue&type=script&lang=js"
import style0 from "./FoodSafetyPanel.vue?vue&type=style&index=0&id=06408a8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06408a8a",
  null
  
)

export default component.exports